import { render } from "./NewsCarousel.vue?vue&type=template&id=c221b8a2&scoped=true"
import script from "./NewsCarousel.vue?vue&type=script&lang=js"
export * from "./NewsCarousel.vue?vue&type=script&lang=js"

import "./NewsCarousel.vue?vue&type=style&index=0&id=c221b8a2&language=scss&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c221b8a2"]])

export default __exports__